
import { CustomToaster } from "../../../reusable-components/Toasters/toaster";
import moment from 'moment';

export const DownloadSummaryExcel = async (summaryBlob) => {
    if (summaryBlob !== undefined) {
        try {
            const href = window.URL.createObjectURL(summaryBlob);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'summary.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.log("Download Excel function has an error: ", err)
            CustomToaster({ type: "error", customized_message: "The K-1s were summarized but the download failed. Please contact support and attach a screenshot.", api_message: err })
        }
    }
};

export const DownloadURI = (url, name) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    window.open(url)
    document.body.removeChild(link);
}

export const CreatedDateRenderer = (date) => {
    const formatDateTime = (date) => {
        if (!date) return "";
        if (!moment(date).isValid()) return "";
        const localFormatted = moment.utc(date).local().format('MM/DD/YYYY hh:mm:ss A');
        return localFormatted;
    };

  return <span>{formatDateTime(date)}</span>;
};